import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import { get } from '@/common/helpers/api_helper'

interface TasaCambioState {
  tasaCambio: number | null
}

const initialState: TasaCambioState = {
  tasaCambio: null,
}

export const getTasaCambio = createAsyncThunk(
  'tasaCambio/getTasaCambio',
  async (region: string[]) => {
    const res = await get(
      `/TasasCambio?$filter=TipoTasa/Nombre eq 'Real' and esVigente and NombreTipoCambio eq '${region[0]}'`,
    )

    return res.value[0].Tasa
  },
)

const tasaCambioSlice = createSlice({
  name: 'tasaCambio',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTasaCambio.fulfilled, (state, action) => {
      state.tasaCambio = action.payload
    })
  },
})

const TasaCambioReducer = tasaCambioSlice.reducer

export default TasaCambioReducer
